import { useEffect, useRef, useState } from 'react';
import { API_BASE } from '../config';
import './SiteMemoEditor.css';

export default function SiteMemoEditor({ site, onSaved }) {
    const [saved, setSaved] = useState({ memo: site.memo || '', version: Number(site.memo_version) || 0 });
    const [draft, setDraft] = useState(null);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [notice, setNotice] = useState('');
    const [conflict, setConflict] = useState(null);
    const busy = useRef(false);
    useEffect(() => {
        setSaved(previous => Number(site.memo_version) > previous.version
            ? { memo: site.memo || '', version: Number(site.memo_version) } : previous);
    }, [site.memo, site.memo_version]);
    const save = async () => {
        if (busy.current || !draft) return;
        if ([...draft.memo].length > 2000) { setError('메모는 2,000자 이하로 입력해 주세요.'); return; }
        busy.current = true; setSaving(true); setError(''); setNotice('');
        try {
            const response = await fetch(`${API_BASE}/api/admin/sites/${site.site_id}/memo`, {
                method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
                body: JSON.stringify({ memo: draft.memo, expected_version: draft.version }),
            });
            const result = await response.json();
            if (!response.ok) {
                if (response.status === 409) setConflict(result.current);
                throw new Error(result.error || '메모를 저장하지 못했습니다.');
            }
            setSaved(result); setDraft(null); setConflict(null); setNotice('저장되었습니다.');
            onSaved?.(site.site_id, { memo: result.memo, memo_version: result.version });
        } catch (error) { setError(error.message); }
        finally { busy.current = false; setSaving(false); }
    };
    return <div className="site-memo-editor">
        {draft ? <>
            <label>사이트 메모<textarea aria-label={`${site.site_name} 사이트 메모`} rows={3} value={draft.memo} disabled={saving}
                onChange={event => setDraft({ ...draft, memo: event.target.value })} /></label>
            <span className="site-memo-length">{[...draft.memo].length} / 2,000자</span>
            {error && <p role="alert">{error}</p>}
            {conflict && <div className="site-memo-conflict"><strong>최신 메모</strong><p>{conflict.memo || '(비어 있음)'}</p><button type="button" disabled={saving} onClick={() => {
                setSaved(conflict); setDraft({ ...conflict }); setConflict(null); setError('');
            }}>최신 메모 불러오기</button></div>}
            <div className="site-memo-actions"><button type="button" disabled={saving} onClick={() => { setDraft(null); setConflict(null); setError(''); }}>취소</button>
                <button type="button" disabled={saving || !!conflict} onClick={save}>{saving ? '저장 중…' : '메모 저장'}</button></div>
        </> : <button type="button" className="site-memo-preview" aria-label={`${site.site_name} 사이트 메모 ${saved.memo ? '수정' : '입력'}`} onClick={() => {
            setDraft({ ...saved }); setError(''); setNotice('');
        }}>{saved.memo || '+ 사이트 메모'}</button>}
        {notice && <span role="status">{notice}</span>}
    </div>;
}
